import * as yup from 'yup';

export const validationSchema = yup.object().shape({
    Themes: yup.string().required('Обязательное поле'),
    Comment: yup.string(),
    Date: yup.string()
        .required('Обязательное поле')
        .test('is-valid-date', 'Неверный формат даты', value => {
            return !value || /^\d{2}\.\d{2}\.\d{4}$/.test(value);
        })
        .test('is-future', 'Дата не может быть в прошлом', value => {
            if (!value) return true;
            const [day, month, year] = value.split('.').map(Number);
            const inputDate = new Date(year, month - 1, day);
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            return inputDate >= today;
        })
});
